import React, { useState, useEffect } from 'react'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'
import DateNotification from '../../components/Notifications/DateNotification'
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from '../../config/index'
const { API_URL } = config

const Notifications = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const token = localStorage.getItem('token')
  const type = localStorage.getItem('type')

  const [notifications, setNotifications] = useState([])
  const [page, setPage] = useState(1)

  const fetchNotifications = async () => {
    let url = `${API_URL}/notification/associate/mynotifications?page=${page}`
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json charset=utf-8',
        },
      })

      let data = await response.json()

      if (data.success) {
        let notificationsData = data.data
        if (notificationsData.length > 0) {
          let sortedArray = notificationsData.sort(
            (a, b) => moment(b.createdAt) - moment(a.createdAt)
          )
          let dateArr = new Set(
            sortedArray.map((notification) =>
              moment(notification.createdAt).format('D MMMM YYYY')
            )
          )
          
          let notificationsArr = [...dateArr].map((date) => {
            let notificationData = sortedArray.filter(
              (notification) =>
                moment(notification.createdAt).format('D MMMM YYYY') ===
                moment(date).format('D MMMM YYYY')
            )

            return {
              date: moment(date).format('D MMMM YYYY'),
              data: notificationData,
            }
          })

          setNotifications([...notifications, ...notificationsArr])
          setPage(page + 1)
        }
      } else {
        ToastUtil.error(data.message)
      }
    } catch (error) {
      ToastUtil.error(error)
    }
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  return (
    <InfiniteScroll
      dataLength={notifications.length} //This is important field to render the next data
      next={fetchNotifications}
      hasMore={true}
      // loader={<h4>Loading...</h4>}
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>Yay! You have seen it all</b>
        </p>
      }
      // below props only if you need pull down functionality
      //   refreshFunction={this.refresh}
      //   pullDownToRefresh
      //   pullDownToRefreshContent={
      //     <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
      //   }
      //   releaseToRefreshContent={
      //     <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
      //   }
    >
      {notifications &&
        notifications.map((notification) => (
          <DateNotification
            key={notification.id}
            date={notification.date}
            notifications={notification.data}
          />
        ))}
    </InfiniteScroll>
  )
}

export default Notifications
